import React, { useState } from 'react';

// Import de la Lightbox et de ses styles de base
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// Optionnel: Import des plugins (miniatures, zoom) et leurs styles
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

// Import du CSS spécifique à notre galerie
import './Gallery.css';

// --- Données pour les images de g1.jpg à g26.jpg ---
const galleryImages = Array.from({ length: 26 }, (_, i) => ({
  id: i + 1,
  src: `/images/g${i + 1}.jpg`,
  alt: `Galerie Fromagerie Chez Paul - Image ${i + 1}`
}));

// Nombre d'images à afficher initialement
const INITIAL_VISIBLE_COUNT = 8;

function Gallery() {
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);
  const [openLightbox, setOpenLightbox] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const showMoreButtonVisible = visibleCount < galleryImages.length;
  const showLessButtonVisible = visibleCount > INITIAL_VISIBLE_COUNT && visibleCount === galleryImages.length;

  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
    setOpenLightbox(true);
  };

  const handleShowMore = () => {
    setVisibleCount(galleryImages.length);
  };

  const handleShowLess = () => {
    setVisibleCount(INITIAL_VISIBLE_COUNT);
    document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' });
  };

  const lightboxSlides = galleryImages.map(img => ({ src: img.src }));

  return (
    <section id="gallery" className="gallery-section">
      <div className="container">
        <h2 className="section-title">Notre Univers en Images</h2>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            index < visibleCount ? (
              <div
                key={image.id}
                className="gallery-item"
                onClick={() => handleImageClick(index)}
                role="button"
                tabIndex={0}
                aria-label={`Voir ${image.alt}`}
                onKeyDown={(e) => e.key === 'Enter' && handleImageClick(index)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="gallery-image"
                  loading="lazy"
                />
                <div className="gallery-item-overlay">
                   <span className="overlay-icon">+</span>
                </div>
              </div>
            ) : null
          ))}
        </div>

        <div className="gallery-controls">
          {showMoreButtonVisible && (
            <button onClick={handleShowMore} className="gallery-button">
              Voir plus
            </button>
          )}
          {showLessButtonVisible && (
            <button onClick={handleShowLess} className="gallery-button">
              Voir moins
            </button>
          )}
        </div>

      </div>

      {/* Composant Lightbox */}
      <Lightbox
        open={openLightbox}
        close={() => setOpenLightbox(false)}
        index={currentImageIndex}
        slides={lightboxSlides}
        plugins={[Thumbnails, Zoom]}
        zoom={{
            maxZoomPixelRatio: 2,
            doubleTapDelay: 300,
            doubleClickDelay: 300,
        }}
        thumbnails={{
            border: 0,
            padding: 0,
            gap: 8,
            imageFit: "cover",
            height: 60,
        }}
        styles={{
            // Styles pour container/thumbnails
            container: { backgroundColor: "rgba(0, 0, 0, .9)" },
            thumbnailsContainer: { backgroundColor: "rgba(0,0,0, .7)" },
            // On laisse la prop 'styles' vide pour le slide pour éviter les conflits
        }}
      />
    </section>
  );
}

export default Gallery;